// useToast() relies on inject(), which only works during a component's synchronous
// setup(). PrintSuccess/PrintError are called from async API handlers (after an
// await), where that context is gone — so the toast API is captured exactly once,
// synchronously, in App.vue's setup via registerToastApi, and reused from here on.
let toastApi: ReturnType<typeof useToast> | undefined

export const registerToastApi = (api: ReturnType<typeof useToast>) => {
    toastApi = api
}

export const PrintSuccess = (message: string) => {
    toastApi?.add({ title: message, color: 'success', duration: 3000 })
}

export const PrintError = (message: string) => {
    toastApi?.add({ title: message, color: 'error', duration: 5000 })
}
